import styled from '@emotion/styled'

export const Wrapper = styled.div`
  height: 1px;
  background-color: #d4d8dd;
  width: 100%;
`
